<template>
  <div>
    <v-text-field
      v-model="value"
      :label="field.name"
      outlined
      dense
      @input="saveValueText($event)"
      @change="saveValue"
      v-if="!loading"
      :rules="!!this.field.required ? required : []"
    />
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
export default {
  props: ["field", "model"],
  data() {
    return {
      value: [],
      loading: true,
      required: [v => !!v || `O campo ${this.field.name} é obrigarório`]
    };
  },
  mounted() {
    this.$emit('componentLoading', true);
    this.value = this.model;
    this.loading = false;
    this.$emit('componentLoading', false);
    this.$emit('fieldReady');
  },
  computed: {
    ...mapState("solicitation", ['solicitation_validate_values']),
  },
  methods: {
    ...mapMutations("forms", ["SET_FORM_EMAIL"]),
    ...mapActions("solicitation", ["updateSolicitationValidateValues"]),
    async saveValueText(selected) {
      await this.updateSolicitationValidateValues({
        text: selected || "",
        value: selected || "",
        model: this.field.name
      });
    },
    saveValue() {
      this.SET_FORM_EMAIL({});
      this.SET_FORM_EMAIL(this.solicitation_validate_values);
    }
  }
};
</script>
<style scoped></style>
